import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

export default function LandingNavigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 100);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Features', href: '#features' },
    { label: 'How it Works', href: '#workflow' },
    { label: 'Pricing', href: '#cta' },
    { label: 'Library', href: '/library' },
    { label: 'Account', href: '/account' },
    { label: 'Pair', href: '/pair' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        isScrolled ? 'bg-[#0B0F10]/90 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center gap-3">
            <img src="/eventtools-logo.svg" alt="Event.Tools" className="w-10 h-10 object-contain" />
            <span className="font-display font-bold text-xl text-white">Event.Tools</span>
          </Link>
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
                <a key={link.label} href={link.href} className="text-sm font-medium text-[#A9B4B8] hover:text-white transition-colors">
                  {link.label}
                </a>
            ))}
          </div>
          <div className="hidden lg:flex items-center gap-4">
            <Link to="/signin" className="text-sm font-medium text-[#A9B4B8] hover:text-white transition-colors">
              Sign in
            </Link>
            <Link
              to="/signin"
              className="px-5 py-2.5 bg-[#FF6B4A] text-white text-sm font-medium rounded-lg hover:brightness-110 transition-all"
            >
              Get early access
            </Link>
          </div>
          <button className="lg:hidden p-2 text-white" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-[#0B0F10]/95 backdrop-blur-md border-b border-white/5">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
                <a key={link.label} href={link.href} className="block text-base font-medium text-[#A9B4B8] hover:text-white transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                  {link.label}
                </a>
            ))}
            <div className="pt-4 border-t border-white/10 space-y-3">
              <Link to="/signin" className="block text-base font-medium text-[#A9B4B8] hover:text-white transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                Sign in
              </Link>
              <Link to="/signin" className="block w-full px-5 py-3 bg-[#FF6B4A] text-white text-center font-medium rounded-lg" onClick={() => setIsMobileMenuOpen(false)}>
                Get early access
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
